import { classNames, useEffect } from 'libs/react';
import { NavigationBar } from 'components/NavigationBar';
import { React } from 'libs/react';
import 'components/ScreenBar.scss';
import { useAccount } from './account/AccountProvider';
/**
 * @component ScreenBar
 * @since 1.0.0
 */
export function ScreenBar(props) {
    const { style, infos, trail, backTrailLabel, count } = Object.assign({ style: 'normal' }, props);
    const account = useAccount();
    const trails = trail == null ? [] : Array.isArray(trail) ? trail : [trail];
    const parent = trails[trails.length - 1];
    // The direct parent is the back link; the levels above it are breadcrumbs
    const back = (parent && {
        route: parent.route,
        label: backTrailLabel ? backTrailLabel : parent.title
    }) ||
        undefined;
    const crumbs = trails
        .slice(0, -1)
        .map((entry) => ({ route: entry.route, label: entry.title }));
    const pageTitle = typeof (infos === null || infos === void 0 ? void 0 : infos.title) === 'string' ? infos.title : null;
    useEffect(() => {
        let title = account.name + ' | Centralio';
        if (pageTitle)
            title = pageTitle + ' | ' + title;
        document.title = title;
    }, [account.name, pageTitle]);
    const className = classNames('screen-bar', 'screen-bar--' + style, props.className);
    return (React.createElement(NavigationBar, { className: className, picto: infos === null || infos === void 0 ? void 0 : infos.picto, title: infos === null || infos === void 0 ? void 0 : infos.title, back: back, crumbs: crumbs, count: count }, props.children));
}
